import Vue from 'vue'
import router from './router'
import store from './store'
import jwtDecode from 'jwt-decode'
import { Auth } from 'aws-amplify'
import * as Config from './config'
/**
* Auth Plugin
*
* (see https://vuejs.org/v2/guide/plugins.html for more info on Vue.js plugins)
*
* Handles login and token authentication using OAuth2.
*/
export default {

  /**
   * Install the Auth class.
   *
   * Creates a Vue-resource http interceptor to handle automatically adding auth headers
   * and refreshing tokens. Then attaches this object to the global Vue (as Vue.auth).
   *
   * @param {Object} Vue The global Vue.
   * @param {Object} options Any options we want to have in our plugin.
   * @return {void}
   */
  install (Vue, options) {
    Vue.http.interceptors.push((request, next) => {
      const token = store.state.auth.accessToken
      const hasAuthHeader = request.headers.has('Authorization')

      if (token && !hasAuthHeader) {
        this.setAuthHeader(request)
      }

      next((response) => {
        if (this._isInvalidToken(response)) {
          return this._refreshToken(request)
        }
      })
    })

    Vue.prototype.$auth = Vue.auth = this
  },

  /**
   * Login
   *
   * @param {Object.<string>} creds The username and password for logging in.
   * @param {string|null} redirect The name of the Route to redirect to.
   * @return {Promise}
   */
  // login (context, creds, redirect) {
  //   var params = { 'ownerId': creds.ownerId, 'userId': creds.userId, 'password': creds.password }
  //   return Vue.http.post(Config.LOGIN_API, JSON.stringify(params))
  //     .then((response) => {
  //       context.removeLoading()
  //       localStorage.setItem('userProfileId', creds.userId)
  //       localStorage.setItem('isAdmin', 'false')
  //       localStorage.setItem('shareKeyBeValid', 'false')
  //       this._storeToken(response)
  //       if (redirect) {
  //         router.push({ name: redirect })
  //       }
  //     })
  //     .catch((error) => {
  //       context.removeLoading()
  //       if (error.body) {
  //         switch (error.status) {
  //           case 400:
  //             context.error = '事業者ID、ユーザーIDもしくはパスワードが間違っています。'
  //             break
  //           case 404:
  //             context.error = '事業者ID、ユーザーIDもしくはパスワードが間違っています。'
  //             break
  //           case 500:
  //             context.error = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
  //             break
  //           case 503:
  //             context.error = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
  //             break
  //           default:
  //             context.error = '事業者ID、ユーザーIDもしくはパスワードが間違っています。'
  //             break
  //         }
  //       } else {
  //         context.error = 'インターネットに接続されていません'
  //       }
  //     })
  // },

  /**
   * Logout
   *
   * Clear all data in our Vuex store (which resets logged-in status) and redirect back
   * to login form.
   *
   * @return {void}
   */
  logout () {
    localStorage.removeItem('userProfileId')
    localStorage.removeItem('ownerId')
    localStorage.removeItem('isAdmin')
    store.commit('CLEAR_ALL_DATA')
    Auth.signOut().then(() => router.push({ path: Config.LOGIN_PATH }))
  },
  /**
   * Set the Authorization header on a Vue-resource Request.
   *
   * @param {Request} request The Vue-Resource Request instance to set the header on.
   * @return {void}
   */
  setAuthHeader (request) {
    // このLineがないとAPIを叩くことができない。
    request.headers.set('Authorization', 'Basic Og==')
    request.headers.set('x-id-token', store.state.auth.accessToken)
  },

  /**
   * Retry the original request.
   *
   * Let's retry the user's original target request that had recieved a invalid token response
   * (which we fixed with a token refresh).
   *
   * @param {Request} request The Vue-resource Request instance to use to repeat an http call.
   * @return {Promise}
   */
  _retry (request) {
    this.setAuthHeader(request)

    return Vue.http(request)
      .then((response) => {
        return response
      })
      .catch((response) => {
        return response
      })
  },

  /**
   * Refresh the access token
   *
   * Make an ajax call to the OAuth2 server to refresh the access token (using our refresh token).
   *
   * @private
   * @param {Request} request Vue-resource Request instance, the original request that we'll retry.
   * @return {Promise}
   */
  _refreshToken (request) {
    console.log(request)
    var check = false
    return new Promise((resolve, reject) => {
      Auth.currentSession()
        .then((user) => {
          var idToken = user.idToken.jwtToken
          var refreshToken = user.refreshToken.token
          // token
          console.log('Session_user: ', user)
          console.log('Session_idtoken: ', idToken)
          console.log('Session_refreshToken: ', refreshToken)
          // user info
          var tk = jwtDecode(user.idToken.jwtToken)
          console.log('Session_token_decode: ', tk)
          console.log('username: ', tk.alligate_user_id)
          // localStorage.setItem('logRefreshToken', 'Refresh the access token is success')
          this._storeToken(idToken, refreshToken)
          check = true
          resolve()
          // return this._retry(request)
          // return this._storeTokenChange(idToken, refreshToken)
          //   .then(() => {
          //     location.reload()
          //   })
        })
        .catch((error) => {
          return new Promise((resolve, reject) => {
            console.error('Unable to refresh Token ', error)
            localStorage.removeItem('userProfileId')
            localStorage.removeItem('ownerId')
            localStorage.removeItem('isAdmin')
            store.commit('CLEAR_ALL_DATA')
            // localStorage.setItem('logRefreshTokenError', 'Refresh the access token is error: ' + error.body.message)
            Auth.signOut().then(() => router.push({ path: Config.LOGIN_PATH }))
            resolve()
          }).then(() => {
            location.reload()
          })
        })
    }).then(() => {
      if (check) {
        return this._retry(request)
      }
    })
    // var params = { 'refreshToken': store.state.auth.refreshToken }
    // return Vue.http.post(Config.REFRESH_TOKEN_API, params)
    //   .then((result) => {
    //     this._storeToken(result)
    //     return this._retry(request)
    //   })
    //   .catch((errorResponse) => {
    //     this.logout()
    //   })
  },

  /**
   * Store tokens
   *
   * Update the Vuex store with the access/refresh tokens received from the response from
   * the Oauth2 server.
   *
   * @private
   * @param {Response} response Vue-resource Response instance from an OAuth2 server.
   *      that contains our tokens.
   * @return {void}
   */
  _storeTokenChange (idToken, refreshToken) {
    return new Promise((resolve, reject) => {
      var auth = store.state.auth
      var user = store.state.user
      auth.isLoginChallenge = false
      auth.isLoggedIn = true
      auth.accessToken = idToken
      auth.refreshToken = refreshToken
      store.commit('UPDATE_AUTH', auth)
      store.commit('UPDATE_USER', user)
      resolve()
    })
  },
  _storeToken (idToken, refreshToken) {
    var auth = store.state.auth
    var user = store.state.user
    auth.isLoginChallenge = false
    auth.isLoggedIn = true
    auth.accessToken = idToken
    auth.refreshToken = refreshToken
    store.commit('UPDATE_AUTH', auth)
    store.commit('UPDATE_USER', user)
  },
  _getProfile () {
    Vue.http.get(Config.USERS_LIST_API + '?userId=' + encodeURIComponent(localStorage.userProfileId))
      .then(response => {
        localStorage.setItem('ownerId', response.body.users[0].owner.ownerId)
        localStorage.setItem('isAdmin', response.body.users[0].isAdmin)
        router.push({ name: 'dashboard' })
      })
      .catch((error) => {
        console.log(error.status)
      })
  },
  /**
   * Check if the Vue-resource Response is an invalid token response.
   *
   * @private
   * @param {Response} response The Vue-resource Response instance received from an http call.
   * @return {boolean}
   */
  _isInvalidToken (response) {
    var status = response.status
    var error = response.body.message
    return (status === 401 && (error === 'The incoming token has expired'))
  },
  _setAuthenToken (user) {
    return new Promise((resolve, reject) => {
      const authStore = store.state.auth
      const userStore = store.state.user
      const idToken = user.signInUserSession.idToken.jwtToken
      authStore.isLoggedIn = true
      authStore.isLoginChallenge = false
      authStore.accessToken = idToken
      authStore.refreshToken = user.signInUserSession.refreshToken.token
      store.commit('UPDATE_AUTH', authStore)
      store.commit('UPDATE_USER', userStore)
      const tk = jwtDecode(idToken)
      localStorage.setItem('userProfileId', tk.alligate_user_id)
      resolve()
    })
  },
  saveCurrentAuthenticatedUser () {
    Auth.currentAuthenticatedUser()
      .then((user) => {
        if (user) {
          return this._setAuthenToken(user)
            .then(() => {
              this._getProfile()
            })
        } else {
          this.errorAuthenticatedUser()
          Promise.resolve()
        }
      })
      .catch((error) => {
        console.error(error)
        this.errorAuthenticatedUser()
      })
  },
  errorAuthenticatedUser () {
    localStorage.clear()
    store.commit('CLEAR_ALL_DATA')
    window.location.href = window.location.origin + '#/login?status=false'
  }
}



// WEBPACK FOOTER //
// ./src/auth.js